import { jsx as _jsx } from "react/jsx-runtime";
import elements from "../..";
const RenderHtmlElement = ({ element, elementProps, elementId }) => {
    const Element = elements[element];
    if (elementProps?.elementHtml?.content) {
        return (_jsx("div", { "editor-html": "true", "editor-elementid": elementId, dangerouslySetInnerHTML: {
                __html: elementProps?.elementHtml?.content,
            } }));
    }
    return (_jsx("div", { "editor-html": "true", "editor-elementid": elementId, children: _jsx(Element, {}) }));
};
export default RenderHtmlElement;
//# sourceMappingURL=RenderHtmlElement.js.map